import React from 'react';
import Markdown from 'markdown-to-jsx';
import { clsx } from 'clsx';
import { s as styles } from '../../../CopilotMessagePart.module-DU9_L9rT.mjs';

const CopilotMarkdown = ({ children }) => React.createElement(Markdown, { className: styles.markdown }, children);
const CopilotTextPart = ({ part, message, className, style }) => {
  const isUser = message.role === "user";
  const contentClass = isUser ? styles.userPart : styles.assistantPart;
  return React.createElement("div", { className: clsx(contentClass, className), style, "data-zds": true }, isUser ? part.text : React.createElement(CopilotMarkdown, null, part.text));
};
CopilotTextPart.displayName = "CopilotTextPart";

export { CopilotMarkdown, CopilotTextPart, CopilotTextPart as default };
//# sourceMappingURL=CopilotTextPart.es.js.map
